const state = {
	isShowOverlayFeatureCommander: false,
	isShowOverlayFeatureProductCommander: false
}

const getters = {
	getIsShowOverlayFeatureCommander(state) {
		return state.isShowOverlayFeatureCommander
	},
	getIsShowOverlayFeatureProductCommander(state) {
		return state.isShowOverlayFeatureProductCommander
	}
}

const mutations = {
	SET_IS_SHOW_OVERLAY_FEATURE_COMMANDER(state, payload) {
		state.isShowOverlayFeatureCommander = payload
	},
	SET_IS_SHOW_OVERLAY_FEATURE_PRODUCT_COMMANDER(state, payload) {
		state.isShowOverlayFeatureProductCommander = payload
	}
}

const actions = {
	setIsShowOverlayFeatureCommander({ commit }, payload) {
		commit('SET_IS_SHOW_OVERLAY_FEATURE_COMMANDER', payload)
	},
	setIsShowOverlayFeatureProductCommander({ commit }, payload) {
		commit('SET_IS_SHOW_OVERLAY_FEATURE_PRODUCT_COMMANDER', payload)
	}
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}

